import {Component, computed, inject, OnInit, signal} from '@angular/core';
import {UserService} from '@core/services/user.service';
import {NgbAlert, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ModalContainerComponent} from '../modal-container/modal-container.component';
import {RouterLink} from '@angular/router';
import {CheckCircleIconComponent} from '@core/svg-icons/check-circle-icon.component';
import {
  UserUniverseMenuComponent
} from '@layout/components/user-universe/user-universe-menu/user-universe-menu.component';
import {TimeOfDayService} from '@core/services/time-of-day.service';

@Component({
  selector: 'app-welcome-modal',
  templateUrl: './welcome-modal.component.html',
  styleUrls: ['./welcome-modal.component.scss'],
  imports: [ModalContainerComponent, CheckCircleIconComponent, NgbAlert, UserUniverseMenuComponent, RouterLink]
})
export class WelcomeModalComponent implements OnInit {
  modalService = inject(NgbModal);
  protected timeOfDayService = inject(TimeOfDayService);
  private userService = inject(UserService);


  customerName = computed(() => {
    if (this.confirmingAccount()) {
      return '';
    }
    return this.userService.customerFirstnameSignal();
  });

  groupVoucherRedirectPath = computed(() => {
    const redirectTo = this.userService.userSignal()?.groupVoucherCode ? '/kundeportal/udvalgt-sortiment' : null;
    return redirectTo;
  });
  isLimitedToGroupVoucher = computed(() => !!this.userService.userSignal()?.limitedToGroupVoucher);

  confirmingAccount = signal(false);
  confirmationKey = '';
  email = '';

  message = signal<string>('');
  errorMessage = signal<string>('');

  ngOnInit() {
    if (this.email && this.confirmationKey) {
      this.confirmAccount();
    }
  }

  timeOfDay() {
    return this.timeOfDayService.timeOfDay();
  }

  confirmAccount() {
    this.message.set($localize`Perfekt! Din konto er nu bekræftet, og du er logget ind.`);
    this.confirmingAccount.set(true);
    this.userService.confirmAccount(this.email, this.confirmationKey).then((data) => {
      this.confirmingAccount.set(false);
    }).catch((err) => {
      if (err.isApolloError) {
        const error = err.graphQLErrors.find((e: any) => {
          return e.debugMessage === 'ACCOUNT_ALREADY_CONFIRMED';
        });
        if (error) {
          const isLoggedIn = this.userService.userSignal()?.id;
          if (isLoggedIn) {
            this.confirmingAccount.set(false);
            this.message.set($localize`Din konto er allerede bekræftet.`);
          } else {
            this.goToLogin();
          }
          return;
        }
      }
      this.errorMessage.set(err.message);
    });
  }

  goToLogin() {
    this.modalService.dismissAll();
    import('../login-modal/login-modal.component').then(({LoginModalComponent}) => {
      const modalReference = this.modalService.open(LoginModalComponent);
      if (this.email) {
        modalReference.componentInstance.email = this.email;
      }
    });
  }

  dismissModal() {
    this.modalService.dismissAll();
  }
}
